module.exports = __webpack_public_path__ + "img/weylchem-3.33d5a3dc.png";